import React from 'react';
import PropTypes from 'prop-types';

import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';

function TrashIcon({
  className,
  color,
  containerColor,
  containerSize,
  label,
  onClick,
  round,
  size,
}) {
  return (
    <WithIconRounded
      round={round}
      containerColor={containerColor}
      containerSize={containerSize}
      className={className}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label={label}
      >
        <path
          d="M10.3333 2.99999H13.6667V4.33333H12.3333V13C12.3333 13.1768 12.2631 13.3464 12.1381 13.4714C12.013 13.5964 11.8435 13.6667 11.6667 13.6667H2.33333C2.15652 13.6667 1.98695 13.5964 1.86192 13.4714C1.7369 13.3464 1.66666 13.1768 1.66666 13V4.33333H0.333328V2.99999H3.66666V0.999995C3.66666 0.823184 3.7369 0.653615 3.86192 0.52859C3.98695 0.403566 4.15652 0.333328 4.33333 0.333328H9.66666C9.84347 0.333328 10.013 0.403566 10.1381 0.52859C10.2631 0.653615 10.3333 0.823184 10.3333 0.999995V2.99999ZM11 4.33333H2.99999V12.3333H11V4.33333ZM5 1.66666V2.99999H9V1.66666H5Z"
          fill={color}
        />
      </svg>
    </WithIconRounded>

  );
}

TrashIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  label: PropTypes.string,
  onClick: PropTypes.func,
  round: PropTypes.bool,
  size: PropTypes.number,
};

TrashIcon.defaultProps = {
  className: 'k-ds-bg-color-light-grey-300',
  color: 'var(--k-ds-color-grey-700)',
  containerColor: null,
  containerSize: 40,
  label: 'Basurero',
  onClick: null,
  round: false,
  size: 14,
};

export default TrashIcon;
